var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M5.8681 5.99997L9.96966 1.11091C10.0384 1.02966 9.9806 0.906218 9.87435 0.906218H8.62748C8.55404 0.906218 8.48373 0.93903 8.43529 0.99528L5.05248 5.02809L1.66966 0.99528C1.62279 0.93903 1.55248 0.906218 1.47748 0.906218H0.230602C0.124352 0.906218 0.0665395 1.02966 0.13529 1.11091L4.23685 5.99997L0.13529 10.889C0.119889 10.9071 0.110009 10.9293 0.106822 10.9528C0.103635 10.9764 0.107275 11.0004 0.11731 11.0219C0.127346 11.0435 0.143355 11.0617 0.163436 11.0744C0.183518 11.0872 0.206829 11.0938 0.230602 11.0937H1.47748C1.55091 11.0937 1.62123 11.0609 1.66966 11.0047L5.05248 6.97184L8.43529 11.0047C8.48216 11.0609 8.55248 11.0937 8.62748 11.0937H9.87435C9.9806 11.0937 10.0384 10.9703 9.96966 10.889L5.8681 5.99997Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertClose);
export default __webpack_public_path__ + "static/media/icon-alert-close.44b0ed8238ce5dc4a288d072cf48ef7d.svg";
export { ForwardRef as ReactComponent };